import { render, staticRenderFns } from "./IconSadFace.vue?vue&type=template&id=6d52f33b&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6d52f33b', component.options)
    } else {
      api.rerender('6d52f33b', component.options)
    }
    module.hot.accept("./IconSadFace.vue?vue&type=template&id=6d52f33b&functional=true&", function () {
      api.rerender('6d52f33b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/IconSadFace.vue"
export default component.exports